import script from "./SetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./SetPassword.vue?vue&type=script&setup=true&lang=js"

import "./SetPassword.vue?vue&type=style&index=0&id=c39a1092&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c39a1092"]])

export default __exports__